import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { UserData } from './DataDefinitions';

const SettingsChangePassword = ({ user, onPasswordChange, error }: { user: UserData, onPasswordChange: (fieldName: string, fieldValue: string) => void, error?: string }) => {
  const { t } = useTranslation();

  const [password, setPassword] = useState(user.password);
  const [confirmPassword, setConfirmPassword] = useState(user.confirmPassword);

  // Function to handle input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === 'password') setPassword(value);
    if (name === 'confirmPassword') setConfirmPassword(value);
    onPasswordChange(name, value);
  };


  return (
    <div className='d-flex gap-3 mb-3'>
      {/*<h4 className="mb-4">{t("SettingsChangePassword.change_password")}</h4>*/}

      <div className="form-icon-container flex-grow-1">
        <Form.Group className="mb-3 text-start">
          <Form.Label htmlFor="password">{t("SettingsChangePassword.new_password")}</Form.Label>

          <Form.Control
            id="password"
            name="password"
            type="password"
            required
            placeholder="New password"
            className="form-icon-input"
            onChange={handleInputChange}
            isInvalid={error != null}
            value={password}
          />
          <Form.Control.Feedback type="invalid">
            {error}
          </Form.Control.Feedback>

        </Form.Group>
      </div>

      <div className="form-icon-container flex-grow-1">
        <Form.Group className="mb-3 text-start">
          <Form.Label htmlFor="password2" className="form-icon-label text-700">{t("SettingsChangePassword.confirm_password")}</Form.Label>

          <Form.Control
            id="confirm_password"
            name="confirmPassword"
            type="password"
            placeholder="Confirm New password"
            className="form-icon-input"
            onChange={handleInputChange}
            value={confirmPassword}
          />
        </Form.Group>

      </div>
    </div>
  );
};

export default SettingsChangePassword;
